import React, { useState, useEffect } from 'react';
import { Form, Formik } from "formik";
import { Button, Row } from "reactstrap";
import { FormattedMessage } from 'react-intl';
import { useParams } from "react-router";
import moment from 'moment';
import { scrollToErrors } from '../../../../helpers/general';
import { CreateCampaignSchema } from '../../../../helpers/schemas';
import { CampaignInfo } from '../createCampaign/CampaignInfo';
import { Messages } from '../../../layout/Messages/Messages';
import {
  NOTIFICATION_COUPON_ACTIONS,
  NOTIFICATION_CREATE_CAMPAIGN,
} from '../../../../config/notifications';
import { getCampaignApi, updateCampaign } from "../../../../api/campaigns/campaigns";
import { Link } from "react-router-dom";
import { ROUTE_CLIENT_CAMPAIGN } from "../../../../config/routes";

function EditCampaignForm(props) {
  const { id } = useParams();
  const [ campaign, setCampaign ] = useState({});
  const { setParentCampaign } = props;

  const [ initialValues, setInitialValues ] = useState({
    name: campaign.name,
    notes: campaign.notes ?? '',
    start_date: campaign.start_date,
    end_date: campaign.end_date,
    campaign_trackings: campaign.campaign_trackings,
  });

  const getCampaign = () => {
    let payload = {
      id: id,
      hideNotification: false,
    };

    getCampaignApi(payload).then(response => {
      if (response && response.data && response.data.id) {
        setCampaign(response.data);
        setParentCampaign(response.data);

        setInitialValues({
          name: response.data.name,
          notes: response.data.notes ?? '',
          start_date: response.data.start_date,
          end_date: response.data.end_date,
          campaign_trackings: response.data.campaign_trackings,
        });
      }
    })
  };

  useEffect( () => {
    getCampaign();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [ ] )

  const getErrorClass = (formikProps, fieldName) => {
    return formikProps && formikProps.touched && formikProps.touched[fieldName] ? formikProps.errors && formikProps.errors[fieldName] !== undefined ? 'custom-is-invalid' : '' : '';
  }

  const saveCampaign = (data) => {
    data.id = id;
    data.start_date = moment(data.start_date).format("YYYY-MM-DD");
    data.end_date = moment(data.end_date).format("YYYY-MM-DD");

    data.campaign_trackings.forEach((item, index) => {
      delete data.campaign_trackings[index].created_at;
      delete data.campaign_trackings[index].updated_at;
    });

    updateCampaign({
      data: data,
      id: data.id,
      notificationId: NOTIFICATION_COUPON_ACTIONS,
    }).then(response => {
      if (response && response.data && response.data.id) {
        setCampaign(response.data);
        setParentCampaign(response.data);

        setInitialValues({
          name: response.data.name,
          notes: response.data.notes,
          start_date: moment(response.data.start_date).toDate(),
          end_date: moment(response.data.end_date).toDate(),
          campaign_trackings: response.data.campaign_trackings,
        });
      }
    });
  }

  return (
    <div className="edit-campaign-form">
      <div className="edit-campaign-form__notifications">
        <Messages/>
        <Messages notificationId={ NOTIFICATION_COUPON_ACTIONS } />
      </div>
      <Formik
        key="update_campaign"
        initialValues={ initialValues }
        validationSchema={ CreateCampaignSchema }
        validateOnChange={ true }
        enableReinitialize={ true }
        onSubmit={
          data => {
            saveCampaign(data);
          }
        }
      >
        {
          formikProps => {
            scrollToErrors( formikProps );

            return (
              <Form className="edit-campaign-form__form">
                <div className="edit-campaign-form__inner-notification">
                  <Messages notificationId={ NOTIFICATION_CREATE_CAMPAIGN } />
                </div>
                <CampaignInfo
                  formikProps={ formikProps }
                  getErrorClass={ getErrorClass }
                  initialValues={ initialValues }
                  setInitialValues={ setInitialValues }
                  campaign={ campaign }
                />
                <Row className="edit-campaign-form__actions justify-content-end m-0">
                  <Button type="submit" color="primary">
                    <FormattedMessage id="button.save" />
                  </Button>
                  <Link className="btn btn-secondary" to={ROUTE_CLIENT_CAMPAIGN}>
                    <FormattedMessage id="messages.go_back"/>
                  </Link>
                </Row>
              </Form>
            );
          }
        }
      </Formik>
    </div>
  )
}

export { EditCampaignForm };
